import $http from '../../axios';
import {Notification} from 'element-ui';

/**
 * Consultar sedes.
 */
export async function fetchBranchOffices({commit}) {
  await $http.get('/api/sedes')
    .then((response) => {
      commit('setBranchOffices', response.data);
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      });
      commit('BranchOfficeError', error.message);
    });
}

/**
 * Consultar bodegas.
 */
export async function fetchBranchOfficeWarehouses({commit, state}, branch_office_id) {
  await $http.get(`/api/bodegas-sedes?branchoffice_id=${branch_office_id}`)
    .then((response) => {
      commit('setBranchOfficesWarehouses', response.data.data);
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      });
    });
}

export async function fetchLines({commit, state}) {
  await $http.get('/api/lista-lineas')
    .then(response => {
      commit('setLines', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box'
      });
      commit('modelError', error.message);
    });
}

//Obtener los marcas
export async function fetchBrands({commit, state}) {

  let params = {
    paginate: false
  };

  await $http.get('/api/marcas', {params})
    .then(response => {
      commit('setBrands', response.data.data);
    })
    .catch(error => {
      console.error(error);
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box'
      });
      commit('brandError', error.message);
    });
}

/**
 * Consultar Kardex consolidado.
 */
export async function getConsolidatedKardex({commit, state}) {
  commit('setPreloader', true);

  await $http.get('/api/kardex-consolidado', {params: state.filters})
    .then((response) => {
      commit('setConsolidatedKardex', response.data.data);
      commit('setPreloader', false);
    })
    .catch((error) => {
      commit('setPreloader', false);
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
      });
    });
}



// WEBPACK FOOTER //
// ./src/modules/consolidated_kardex/actions.js